<mat-card appearance="outlined">
  <div class="title-container">
    <mat-form-field *ngIf="isMain">
      <input [(ngModel)]="dynamicContent.title" matInput placeholder="{{'general.title' | translate}}" required/>
    </mat-form-field>
    <mat-form-field *ngIf="!isMain">
      <textarea [(ngModel)]="dynamicContent.title" matInput placeholder="{{'dynamicContent.question' | translate}}" required></textarea>
    </mat-form-field>
  </div>
  <form *ngIf="!isMain" [formGroup]="form">
    <mat-form-field>
      <mat-select formControlName="type" placeholder="{{'dynamicContent.type' | translate}}" required>
        <mat-option *ngFor="let type of types" [value]="type">{{'dynamicContent.' + type | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="form.get('type').value && (form.get('type').value === 'singleChoice' || form.get('type').value === 'multipleChoice')">
      <mat-label>{{'dynamicContent.answers' | translate}}</mat-label>
      <mat-chip-grid #chipList>
        <mat-chip-row (removed)="remove(answer)" *ngFor="let answer of answers">
          {{answer}}
          <button matChipRemove><mat-icon>cancel</mat-icon></button>
        </mat-chip-row>
        <input (matChipInputTokenEnd)="add($event)" [matChipInputAddOnBlur]="addOnBlur" [matChipInputFor]="chipList"
               [matChipInputSeparatorKeyCodes]="separatorKeysCodes" placeholder="{{'dynamicContent.feedback.newAnswer' | translate}}">
      </mat-chip-grid>
    </mat-form-field>
    <ng-container *ngIf="form.get('type').value && form.get('type').value === 'scale'">
      <div class="scale">
        <mat-form-field>
          <mat-select formControlName="scaleIcon" placeholder="{{'dynamicContent.scaleIcon' | translate}}" required>
            <mat-option *ngFor="let type of scaleIconType" [value]="type">{{'dynamicContent.' + type | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="scaleMin" matInput placeholder="{{'dynamicContent.scaleMin' | translate}}" required>
        </mat-form-field>
        <mat-form-field>
          <input (input)="checkMax($event)" formControlName="scaleMax" matInput
                 max="{{form.controls.scaleIcon.value === 'numeric' ? null : '10'}}" placeholder="{{'dynamicContent.scaleMax' | translate}}" required type="number">
          <mat-hint *ngIf="form.controls.scaleIcon.value && form.controls.scaleIcon.value !== 'numeric'">{{'dynamicContent.feedback.maxMessage' | translate}}</mat-hint>
        </mat-form-field>
        <mat-form-field *ngIf="form.get('scaleIcon').value === 'numeric'">
          <input formControlName="scaleStep" matInput placeholder="{{'dynamicContent.scaleStep' | translate}}" required>
        </mat-form-field>
      </div>
    </ng-container>
    <ibex-checkbox [title]="'dynamicContent.mandatory' | translate" [checked]="dynamicContent.content.mandatory" (click)="dynamicContent.content.mandatory = $event.val"></ibex-checkbox>
  </form>
</mat-card>
